require('/ui/components/multistep/multistep.module.scss.module.css');

export const container = "_container_1iip5_1";
export const step = "_step_1iip5_1";
export const stepSelected = "_step-selected_1iip5_1";
export const stepUnselected = "_step-unselected_1iip5_1";
export const wrapper = "_wrapper_1iip5_1";
export const stepContainer = "_step-container_1iip5_1";
export const stepNameContainer = "_step-name-container_1iip5_1";
export const stepName = "_step-name_1iip5_1";
export const stepIndicatorContainer = "_step-indicator-container_1iip5_1";
export const stepIndicatorWDropdown = "_step-indicator-w-dropdown_1iip5_1";
export const stepIndicatorWDropdownWrapper = "_step-indicator-w-dropdown-wrapper_1iip5_1";
export const stepIndicatorWoDropdown = "_step-indicator-wo-dropdown_1iip5_1";
export const stepIndicatorWoDropdownWrapper = "_step-indicator-wo-dropdown-wrapper_1iip5_1";
export const triggerContainer = "_trigger-container_1iip5_1";
export const trigger = "_trigger_1iip5_1";
export const actionName = "_action-name_1iip5_1";
export const stepMobile = "_step-mobile_1iip5_1";
export const padding = "_padding_1iip5_1";
